var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfstart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.61021 6.61021L4.76966 3.13184H5.48118L6.64063 6.61021L10.119 7.76966V8.48118L6.64063 9.64063L5.48118 13.119H4.76966L3.61021 9.64063L0.131836 8.48118V7.76966L3.61021 6.61021Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1727 1.92271L10.7697 0.131836H11.4812L12.0781 1.92271L13.869 2.51967V3.23118L12.0781 3.82814L11.4812 5.61901H10.7697L10.1727 3.82814L8.38184 3.23118V2.51967L10.1727 1.92271Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfstart);
export default __webpack_public_path__ + "static/media/pdfstart.bec3ef9301921af99811f840dc3b95f6.svg";
export { ForwardRef as ReactComponent };